import React from 'react';

import { keyframes } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import { AtlassianIcon } from '@atlaskit/logo';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import type { SpinnerProps } from '@atlaskit/spinner';

const loading = keyframes({
	'0%': { opacity: 0.7 },
	'50%': { opacity: 1 },
	'100%': { opacity: 0.7 },
});

const styles = cssMap({
	loadingSpinnerStyles: {
		height: '100%',
	},
	logoStyles: {
		animation: `${loading} 1.5s infinite`,
	},
});

type LoadingLogoProps = Pick<SpinnerProps, 'interactionName' | 'testId'>;

export const LoadingLogo = ({ interactionName, testId = 'loading-logo' }: LoadingLogoProps) => (
	<UFOLoadHold name={interactionName ?? 'studio-loading-atlassian-logo'}>
		<Stack
			grow="fill"
			alignBlock="center"
			alignInline="center"
			xcss={styles.loadingSpinnerStyles}
			testId={testId}
		>
			<Box xcss={styles.logoStyles}>
				<AtlassianIcon appearance="brand" size="xlarge" />
			</Box>
		</Stack>
	</UFOLoadHold>
);
